import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ILocaleState } from '../../interfaces';

export const getters: GetterTree<ILocaleState, RootState> = {
  locale: (state) => state.locale,
};
